import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCandidacyId } from "@/hooks/useCurrentCandidacyId";
import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { useGetCurrentUser } from "@/hooks/queries/useGetCurrentUser";
import { CandidacyStatusChange, CandidacyStatus } from "@/types";

export const useAddCandidacyStatusChange = () => {
  const currentCandidacyId = useCurrentCandidacyId();
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();
  const currentUser = useGetCurrentUser();

  return ({
    fromStatus,
    statusChangeReason,
    toStatus,
  }: {
    fromStatus: CandidacyStatus;
    statusChangeReason: string | null;
    toStatus: CandidacyStatus;
  }) => {
    queryClient.setQueryData(
      [
        "candidacy_status_changes",
        currentCompanyId,
        currentJobId,
        currentCandidacyId,
      ],
      (cachedData: CandidacyStatusChange[] | undefined) => {
        if (!cachedData) return cachedData;

        const candidacyStatusChange = {
          createdAt: new Date().toISOString(),
          fromStatus,
          statusChangeReason,
          toStatus,
          userId: currentUser?.id,
        };
        return [candidacyStatusChange, ...cachedData];
      },
    );
  };
};
